import {z} from 'zod'
import {ResourceLinkSchema} from '@/resource-link/resourceLink'
import {TransactionEntryLineSchema} from '@/types/transaction/TransactionEntryLine'

const TransactionEntryLinePartialSchema = TransactionEntryLineSchema.partial()
export const BookkeepableSchema = z.object({
    type: z.literal('Bookkeepable'),
    documentMetaUuids: z.array(z.uuid()),
    transactionEntryLines: z.array(TransactionEntryLinePartialSchema),
    resourceLinks: z.array(ResourceLinkSchema),
})


export type TransactionEntryLinePartial = z.infer<typeof TransactionEntryLinePartialSchema>
export type Bookkeepable = z.infer<typeof BookkeepableSchema>